import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
import Logo1 from '../../assets/images/logo1.png';

const Footer = () => {
    return (
        <footer className="bg-zinc-900 text-white py-8">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                    {/* Logo */}
                    <div className="mb-4 md:mb-0 flex items-start space-x-2">
                        <img
                            src={Logo1}
                            alt="Logo"
                            className="w-12 h-auto object-contain"
                        />
                        <div>
                            <h3 className="text-2xl font-bold tracking-wider uppercase leading-tight">
                                <span style={{ color: '#7bae37' }}>Berlin</span>
                                <span className="text-white">Tiffin</span>
                            </h3>
                            {/* <p className="text-xs text-gray-500 mt-1">Powered by Swadistha Restaurant</p> */}
                        </div>
                    </div>

                    {/* Social Media Links */}
                    <div className="flex space-x-4">
                        <a
                            href="#"
                            className="p-2 bg-zinc-800 rounded-full transition-colors hover:bg-green-600"
                            aria-label="Facebook"
                        >
                            <Facebook size={20} />
                        </a>
                        <a
                            href="#"
                            className="p-2 bg-zinc-800 rounded-full transition-colors hover:bg-green-600"
                            aria-label="Instagram"
                        >
                            <Instagram size={20} />
                        </a>
                        <a
                            href="#"
                            className="p-2 bg-zinc-800 rounded-full transition-colors hover:bg-green-600"
                            aria-label="Twitter"
                        >
                            <Twitter size={20} />
                        </a>
                    </div>
                </div>

                {/* Divider Line */}
                <div className="w-full h-px bg-zinc-700 my-4"></div>

                {/* Copyright */}
                <div className="text-center text-sm text-gray-400">
                    <p>
                        © {new Date().getFullYear()} BerlinTiffin. All rights reserved. |
                        Designed & Developed by{' '}
                        <a
                            href="https://www.alphaaiservice.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Alpha AI Service
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;